import VCPrograms from './VCPrograms';

export default VCPrograms;
